import { TextAlignment } from '@/src/components';
import { Icon } from '@/src/tools/icon';
import { get, isNumber } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { NumberInput } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { Field } from 'src/components/RcForm';
import { itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm/tools';
import Slider from 'src/components/Slider/MarginSlider';
import Editor from 'src/constrains/BraftEditor';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  content,
  fontSizeMultiply,
  text,
  textAlignment,
  textBoxWidth,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import css from './css.module.less';
const Text = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, breakpoint, fieldNames, validator } = props;
  const isWide = breakpoint === EPreviewSize.WIDE;
  const _params: any = useParams();
  const { contentUuid } = _params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  return (
    <>
      <Section
        {...{
          size: 'small',
          bottomBorder: true,
          style: { paddingTop: 0 },
        }}>
        <Field
          name={fieldNames?.text || [content, text]}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (validator) {
                  const res = validator(value, { breakpoint });

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const e = itemWrapperErrorDisplayAdaptor(m);
            return (
              <ItemWrapper title={getI18n('general.text')} {...e}>
                <Editor
                  eventProps={{ breakpoint }}
                  placeholder={getI18n('general.managetextcontentformat')}
                  disabled={disabled}
                  linkSet={linkSet}
                  data={props.value}
                  onChange={({ data }) => {
                    props.onChange(data);
                  }}
                />
              </ItemWrapper>
            );
          }}
        </Field>

        {!isWide && (
          <Field name={fieldNames?.fontSize || [content, fontSizeMultiply]}>
            {(props, meta, { getFieldsValue }) => {
              return (
                <Slider
                  max={1000}
                  min={0}
                  title={getI18n('general.fontSizeMultiple')}
                  customIcon={
                    <Icon type={'icona-fontsize'} className={css.icon} />
                  }
                  value={props.value}
                  onChange={(v) => {
                    props.onChange(v);
                  }}
                  suffix={'%'}
                />
              );
            }}
          </Field>
        )}
        {!isWide && (
          <ItemWrapper title={getI18n('general.textAlignment')}>
            <Field name={fieldNames?.textAlignment || [content, textAlignment]}>
              {(props, meta) => {
                return (
                  <TextAlignment
                    value={props.value}
                    onChange={(v) => {
                      props.onChange(v);
                    }}
                  />
                );
              }}
            </Field>
          </ItemWrapper>
        )}
      </Section>
      <Section
        {...{
          size: 'small',
          // bottomBorder: true,
        }}>
        <ItemWrapper title={getI18n('general.textBoxWidth')} size='small'>
          <Field name={fieldNames?.textBoxWidth || [content, textBoxWidth]}>
            {(props, meta) => {
              return (
                <NumberInput
                  suffix={'px'}
                  value={props.value}
                  size={'large'}
                  disabled={disabled}
                  min={0}
                  onChange={(textBoxWidth) => {
                    if (isNumber(textBoxWidth)) {
                      props.onChange(textBoxWidth);
                    } else {
                      props.onChange(0);
                    }
                  }}
                />
              );
            }}
          </Field>
        </ItemWrapper>
      </Section>
    </>
  );
};
export default Text;
